// extracted by mini-css-extract-plugin
module.exports = {"edit":"_1ZDCW7er0O"};